import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import EventBus from '@/utils/eventBus'

const ECIRCULARS_PATH = '/ecirculars'

// id for copy/duplicate, type for creating new e-circular
export async function createECircular ({id, type}) {
  try {
    const response = await HTTP.post(`${ECIRCULARS_PATH}`, {id, type})
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function getAllECircular (query) {
  try {
    const response = await HTTP.get(`${ECIRCULARS_PATH}`, { params: query })
    EventBus.emit('resultsCategories', response.data.resultsCategories || [])
    EventBus.emit('getAllECircular', response.data.data || [])
    return response.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function getRecipientTrees (query) {
  try {
    const response = await HTTP.get(`${ECIRCULARS_PATH}/recipient_trees`, { params: query })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function updateECircularById (id, ecircular) {
  try {
    const response = await HTTP.put(`${ECIRCULARS_PATH}/${id}`, ecircular)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function updateECircularStatus (id, status) {
  try {
    const response = await HTTP.patch(`${ECIRCULARS_PATH}/${id}`, {status})
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function getECircularById (id) {
  try {
    const response = await HTTP.get(`${ECIRCULARS_PATH}/${id}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function persistRecipientsSelection (ecircular, showNotification) {
  try {
    const payload = { ...ecircular.histories[0] }
    if (ecircular.userType !== undefined) {
      payload.userType = ecircular.userType
    }
    const response = await HTTP.put(`${ECIRCULARS_PATH}/${ecircular.id}/recipients`, payload)
    if (showNotification) {
      notification.handleResponseAlert(response)
    }
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function sendTestMail (id, body) {
  try {
    const response = await HTTP.post(`${ECIRCULARS_PATH}/testemail/${id}`, body)
    notification.handleResponseAlert(response)
    return response.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function sendMail (id, historyId, request) {
  try {
    const response = await HTTP.post(`${ECIRCULARS_PATH}/send/${id}/${historyId}`, request)
    return response.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function updateHistory (historyId, request) {
  try {
    const response = await HTTP.put(`${ECIRCULARS_PATH}/histories/${historyId}`, request)
    notification.handleResponseAlert(response)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}
